import React from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Image, Menu, Dropdown } from "semantic-ui-react";
import { signOutFirebase } from "../../app/firestore/firebaseService";
import { partyIsAgent } from "../../app/common/util/util";

export default function NavBarParty() {
  const location = useLocation();
  const navigate = useNavigate();
  const { partyId } = useParams();
  const { authenticated } = useSelector((state) => state.auth);
  const { party, tasksTrans } = useSelector((state) => state.party);
  const { currentUserProfile } = useSelector((state) => state.profile);

  function handleSignOut() {
    signOutFirebase();
    navigate(`/partyLogin`);
  }

  return (
    <>
      <Menu secondary stackable className="main-menu">
        <Menu.Item header style={{ marginLeft: "0px", paddingLeft: "0px" }}>
          <Image src="/assets/logo-color-with-text-small.png" />
        </Menu.Item>
        {authenticated && party?.email && (
          <>
            {currentUserProfile?.type === "user" && (
              <Menu.Item
                as={NavLink}
                active={location.pathname === "/overview"}
                to={`/overview`}
                name="My Dashboard"
              />
            )}
            <Menu.Item
              as={NavLink}
              active={location.pathname.includes("overviewParty")}
              to={`/overviewParty`}
              name="All Transactions"
            />
            <Menu.Item
              as={NavLink}
              active={location.pathname.includes("documents")}
              to={`/party/${partyId}/documents`}
              name="Documents"
            />
            {tasksTrans.length !== 0 && (
              <Menu.Item
                as={NavLink}
                to={`/party/${partyId}/calendar`}
                name="Calendar"
              />
            )}
            <Menu.Item
              as={NavLink}
              to={`/party/${partyId}/contacts`}
              name="Contacts"
            />
            {/* History is only relevant to the agent side (agent/coagent/assistant/TC
                all share this same party record and portal link) — hide it for
                buyer/seller clients and other non-agent parties. */}
            {partyIsAgent(party?.role) && (
              <Menu.Item
                as={NavLink}
                to={`/party/${partyId}/history`}
                name="History"
              />
            )}
            <Menu.Item position="right">
              <Dropdown
                pointing="top left"
                direction="left"
                text={currentUserProfile?.lastName ? (
                  currentUserProfile?.firstName +
                  " " +
                  currentUserProfile?.lastName
                ) : "Account"
                }
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={handleSignOut}
                    text="Sign Out"
                    icon="power"
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Item>
          </>
        )}
      </Menu>
    </>
  );
}
